// import Loader from "./loader";
// import Cookies from "js-cookie";
// import * as XLSX from "xlsx";
// import { FiDownload } from "react-icons/fi";

// const SellersTable = ({ products, indexing }) => {
//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return Intl.DateTimeFormat("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     }).format(date);
//   };
//   const formatTime = (dateString) => {
//     const date = new Date(dateString);
//     return Intl.DateTimeFormat("en-US", {
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//     }).format(date);
//   };
//   const getDate = (date) => {
//     const formattedDate = new Date(date);
//     return formattedDate.toLocaleDateString("en-GB");
//   };
//   //   const UserDetailsHandler = (item) => {
//   //     console.log(item);
//   //     try {
//   //       const cleanedLeads = item.map(
//   //         ({ __v, _id, updatedAt, createdAt, customer, ...rest }) => ({
//   //           ...rest,
//   //           createdAt: getDate(createdAt),
//   //           ...customer,
//   //         })
//   //       );
//   //       const jsonData = JSON.stringify(cleanedLeads);
//   //       const worksheet = XLSX.utils.json_to_sheet(JSON.parse(jsonData));
//   //       const workbook = XLSX.utils.book_new();
//   //       XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
//   //       XLSX.writeFile(workbook, "leads_data.xlsx");
//   //     } catch (error) {
//   //       console.error("Error:", error);
//   //     }
//   //   };

//   const UserDetailsHandler = (item) => {
//     // console.log(item);
//     try {
//       const { __v, _id, updatedAt, createdAt, customer, ...rest } = item;
//       const cleanedLeads = {
//         ...rest,
//         createdAt: getDate(createdAt),
//         ...customer,
//       };
//       const worksheet = XLSX.utils.json_to_sheet([cleanedLeads]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
//       XLSX.writeFile(workbook, "leads_data.xlsx");
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   return (
//     <table className="text-left table-auto w-full border-separate border-spacing-y-1 scroll-smooth ">
//       <thead className="bg-gray-200 text-sky-900  sticky top-0 ">
//         <tr className="uppercase">
//           <th>sn</th>
//           <th>Name & Email</th>
//           <th>Phone</th>
//           <th>date</th>
//           <th>company name</th>
//           <th>device</th>
//           <th>store name</th>
//           <th>csv</th>
//         </tr>
//       </thead>
//       <tbody className="">
//         {products && products.length !== 0 ? (
//           products.map((item, index) => {
//             return (
//               <tr key={index} className="odd:bg-white even:bg-gray-50 border-b">
//                 <td>{index + 1 + (indexing - 1) * 20}</td>
//                 <td className="text-start">
//                   <td className="flex flex-col justify-center p-0">
//                     <td className="font-semibold p-0">{item.name}</td>
//                     <td className="text-gray-300 p-0">{item.email}</td>
//                   </td>
//                 </td>
//                 <td>{item.mobile}</td>
//                 <td>
//                   <td className="flex flex-col p-0">
//                     <td className="p-0">{formatDate(item.createdAt)}</td>
//                     <td className="text-gray-400 p-0">
//                       {formatTime(item.createdAt)}
//                     </td>
//                   </td>
//                 </td>
//                 <td>{item.company_name}</td>
//                 <td>{item.device} </td>
//                 <td>{item.store_name}</td>
//                 <td className="group">
//                   <span
//                     className={" text-2xl  cursor-pointer"}
//                     onClick={() => UserDetailsHandler(item)}
//                   >
//                     <FiDownload />
//                   </span>
//                 </td>
//               </tr>
//             );
//           })
//         ) : (
//           <Loader className="absolute  mt-32" style="text-[7px]" />
//         )}
//       </tbody>
//     </table>
//   );
// };

// export default SellersTable;


import React from "react";
import {
  Card,
  DataTable,
  Text,
  BlockStack,
  Spinner,
  EmptyState,
  Button,
} from "@shopify/polaris";
import { ExportIcon } from "@shopify/polaris-icons";
import * as XLSX from "xlsx";

const SellersTable = ({ products, indexing = 1 }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  };

  const formatTime = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).format(date);
  };

  const getDateForExport = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB");
  };

  const handleExportSingle = (item) => {
    try {
      const { __v, _id, updatedAt, createdAt, customer, ...rest } = item;

      const cleanedData = {
        ...rest,
        createdAt: getDateForExport(createdAt),
        ...(customer || {}),
      };

      const worksheet = XLSX.utils.json_to_sheet([cleanedData]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Seller");
      XLSX.writeFile(workbook, `seller_${item.name || "data"}_${Date.now()}.xlsx`);
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  const rows = products?.map((item, index) => [
    index + 1 + (indexing - 1) * 20,

    <BlockStack gap="100">
      <Text variant="bodyMd" fontWeight="bold" as="span">
        {item.name || "—"}
      </Text>
      <Text variant="bodySm" tone="subdued" as="span">
        {item.email || "—"}
      </Text>
    </BlockStack>,

    item.mobile || "—",

    <BlockStack gap="100">
      <Text variant="bodyMd" as="span">
        {formatDate(item.createdAt)}
      </Text>
      <Text variant="bodySm" tone="subdued" as="span">
        {formatTime(item.createdAt)}
      </Text>
    </BlockStack>,

    item.company_name || "—",
    item.device || "—",
    item.store_name || "—",

    <Button
      size="micro"
      icon={ExportIcon}
      onClick={() => handleExportSingle(item)}
      accessibilityLabel="Export this seller as CSV/XLSX"
      plain
    />,
  ]) || [];

  const columnContentTypes = [
    "numeric",
    "text",
    "text",
    "text",
    "text",
    "text",
    "text",
    "text",
  ];

  const headings = [
    "SN",
    "Name & Email",
    "Phone",
    "Date",
    "Company Name",
    "Device",
    "Store Name",
    "CSV",
  ];

  return (
    <Card>
      {products?.length > 0 ? (
        <DataTable
          columnContentTypes={columnContentTypes}
          headings={headings}
          rows={rows}
          hoverable
          increasedTableDensity
          stickyHeader
          verticalAlign="middle"
        />
      ) : (
        <div className="py-12">
          {products === undefined ? (
            <BlockStack align="center" inlineAlign="center" gap="400">
              <Spinner accessibilityLabel="Loading sellers" size="large" />
              <Text variant="bodyMd" tone="subdued">
                Loading sellers data...
              </Text>
            </BlockStack>
          ) : (
            <EmptyState
              heading="No sellers found"
              image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
            >
              <p>No seller records available at the moment.</p>
            </EmptyState>
          )}
        </div>
      )}
    </Card>
  );
};

export default SellersTable;